<template>
  <h3
    v-if="engine != null"
    class="mb-1"
  >
    {{engine.display_name}}
    <v-btn
      v-if="engine.issi.length == 7"
      icon
      x-small
      disabled
      @click="$router.push({path: '/sds', query: {issi: engine.issi}})"
    >
      <v-icon
      >
        mdi-note-text-outline
      </v-icon>
    </v-btn>
    <Status
      class="float-right"
      :engine="engine"
      :replace_status_with_displayName="false"
    ></Status>
    <v-icon
      v-if="engine.visualize_alarm"
      class="mx-2 float-right"
      color="error"
    >
      mdi-alarm
    </v-icon>

  </h3>
</template>

<script>
import Status from "./Status";
export default {
  name: "Station_Engine",
  components: { Status },
  props: ["issi"],
  data: () => ({
  }),
  computed: {
    engine(){
      let engine = this.$store.getters.get_engine(this.issi)
      if(engine == null){
        this.$store.dispatch("update", { "context": "/engines/" + this.issi  })
      }
      return engine
    }
  },
};
</script>

<style scoped>

</style>
